import type {
	BatchDeleteTransferPlayersInput,
	createActivePlayerInput,
	deleteActivePlayerInput,
	getActivePlayerInput,
	getActivePlayerSuggestionsFacetsInput,
	getActivePlayerSuggestionsInput,
	getActivePlayersFacetsInput,
	getAllActivePlayersInput,
	getPlayerDatabaseInput,
	postAdminAllActivePlayersInput,
	updateActivePlayerInput,
} from "@/api/custom_types";
import { createReactQueryKeys } from "@/utils/react-query";

interface KeyTypes {
	useGetAllActivePlayers: getAllActivePlayersInput;
	useGetActivePlayersFacets: getActivePlayersFacetsInput;
	useGetActivePlayerSuggestions: getActivePlayerSuggestionsInput;
	useGetActivePlayerSuggestionsFacets: getActivePlayerSuggestionsFacetsInput;
	useCreateActivePlayer: createActivePlayerInput;
	useCreateActivePlayers: postAdminAllActivePlayersInput;
	useGetActivePlayer: getActivePlayerInput;
	useUpdateActivePlayer: updateActivePlayerInput;
	useDeleteActivePlayer: deleteActivePlayerInput;
	useBatchDeleteTransferPlayers: BatchDeleteTransferPlayersInput;
	useBatchUpdateTransferPlayers: undefined;
	useGetPlayerDatabase: getPlayerDatabaseInput;
	useGetPlayerDatabaseFacets: getPlayerDatabaseInput;
	useRefreshPlayerPrices: undefined;
}

const ACTIVE_PLAYERS_SERVICE_KEYS = createReactQueryKeys<KeyTypes>(
	"active-players",
	[
		"useGetAllActivePlayers",
		"useGetActivePlayersFacets",
		"useGetActivePlayerSuggestions",
		"useGetActivePlayerSuggestionsFacets",
		"useCreateActivePlayer",
		"useCreateActivePlayers",
		"useGetActivePlayer",
		"useUpdateActivePlayer",
		"useDeleteActivePlayer",
		"useBatchDeleteTransferPlayers",
		"useBatchUpdateTransferPlayers",
		"useGetPlayerDatabase",
		"useGetPlayerDatabaseFacets",
		"useRefreshPlayerPrices",
	],
);

export { ACTIVE_PLAYERS_SERVICE_KEYS };
